import VueLoader from '../../default/vue-loader'
import { store } from'../../default/store'
import TermsAndConditions from './terms-and-conditions'

document.addEventListener('turbo:load', () => {
  VueLoader.loadVueComponent(TermsAndConditions,
    document.getElementById('TermsAndConditions'), store)
})
